import { DataView24, UserAvatar24 } from "@carbon/icons-react";
import {
  Button,
  ButtonSet,
  Column,
  Form,
  FormGroup,
  Loading,
  Row,
  TextArea,
  TextInput,
} from "carbon-components-react";
import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "../../components/Card/Card";
import { AuthContext } from "../../contexts/AuthContext";
import http from "../../http-common";
import useTraineeProfile from "../../hooks/useTraineeProfile";
import useAuth from "../../hooks/useAuth";
import PaginatedDataTable from "../../components/Table/PaginatedDataTable";
import DataOperationButton from "../../components/Buttons/DataOperationButton";
import InternshipFillingInstructions from "../../components/Miscellaneous/InternshipFillingInstructions";

const tableHeaders = [
  {
    header: "Título",
    key: "vacancyTitle",
  },
  {
    header: "Empresa",
    key: "companyName",
  },

  {
    header: "Visualizar",
    key: "vacancyUuid",
  },
];

const TraineeDashboardPage = () => {
  const { user } = useAuth();
  const [profile, setProfile] = useState(null);
  const [items, setItems] = useState([]);

  const navigate = useNavigate();

  const getCellContent = (cell, id) => {
    if (cell.info.header === "vacancyUuid") {
      return (
        <DataOperationButton
          operations={[
            {
              id: id,
              url: `../vagas-para-estagio/${cell.value}`,
              icon: DataView24,
              title: "Consultar",
            },
          ]}
        />
      );
    }

    return cell.value;
  };

  const loadProfile = async () => {
    try {
      const response = await http.get(`/internships/trainees/${user.username}`);
      setProfile(response.data);
    } catch (error) {
      // navigate("../perfil-estagiario");
    }
  };

  const getApplications = async () => {
    try {
      const response = await http.get(
        `/internships/trainees/${user.username}/applications`
      );
      setItems(response.data);
    } catch (error) {}
  };

  useEffect(() => {
    loadProfile();
    getApplications();
  }, []);

  return (
    <Card title={"Olá " + user.firstName + " " + user.lastName}>
      <ButtonSet>
        <Button
          renderIcon={UserAvatar24}
          iconDescription="Meu Perfil"
          onClick={() => navigate("../perfil-estagiario/")}
        >
          Meu Perfil
        </Button>
        <Button
          renderIcon={DataView24}
          iconDescription="Meu Perfil"
          onClick={() => navigate("../vagas-para-estagio/")}
        >
          Vagas de estágio
        </Button>
      </ButtonSet>
      <InternshipFillingInstructions />
      <h4 className="mt-2">Minhas Candidaturas</h4>
      <PaginatedDataTable
        headers={tableHeaders}
        items={items}
        paginate={false}
        getCellContent={getCellContent}
      ></PaginatedDataTable>
    </Card>
  );
};

export default TraineeDashboardPage;
